<label  [attr.for]="id || for" class="field__label">{{label}}</label>
<input [(ngModel)]="text" (ngModelChange)="onValueChange.emit(text)" [disabled]="disabled" [id]="id || for"
       class="field__input" type="{{type}}" maxlength="{{maxlength}}" minlength="{{minlength}}" (blur)="onBlur()"
       [attr.aria-describedby]="getDescribedBy()"
       [attr.aria-required]="requiredField ? 'true' : null" role="textbox"
       [attr.aria-invalid]="errorMessages.length>0"
       [ngClass]="{'field__input--error': errorMessages.length}" />
<div class="field__message"
     [id]="(id||for) + '-helper'"
     [ngClass]="{'hide': !helperText}"
     [attr.aria-live]="helperText ? 'polite' : null">
    {{helperText}}
</div>
<div *ngIf="errorMessages.length"
     [id]="(id||for)+'-error'"
     class="error-message">
    <ErrorMessages [errorMessages]="errorMessages" [for]="(id||for)"></ErrorMessages>

</div>